import { Injectable } from '@angular/core';
import { ConfigInterface } from '../../_model/config/config.interface';
import { StorageService } from '../../storageprovider';
import { Utility } from '../utility';
import { ApiUrlHelper } from '../api-url-helper';
import { HttpClientHelper } from '../http-helper';
import { map } from 'rxjs/operators';
import { BehaviorSubject, of } from 'rxjs';
import { InjectHttpClient } from '../InjectHttpClient';

@Injectable()
export class ConfigService {
    _config: BehaviorSubject<any> = new BehaviorSubject({});
    config$ = this._config.asObservable();

    constructor(
        private _storage: StorageService,
        private _apiUrlHelper: ApiUrlHelper,
        private _httpClientHelper: HttpClientHelper,
        private _utility: Utility,
        private _inject: InjectHttpClient
    ) {
    }

    getConfigAll(): ConfigInterface {

        return {
            region: this._storage.GetConfig()["region"] || "GL.",
            logoUrl: '',
            vod: this._storage.GetConfig()["vod"],
            vipListOpenStatus: false,
            guestListOpenStatus: false,
            //allVip: false,
        };
    }

    getConfig(key) {
        const config = this.getConfigAll();
        return config[key];
    }

    setConfig(key, value) {
        const oldConfig = this.getConfigAll();
        oldConfig[key] = value;
        //this._cookieService.set('config', this.stringfyConfig(oldConfig), null, '/');
    }

    stringfyConfig(c) {
        const s = [];
        for (const a in c) {
            if (c.hasOwnProperty(a)) {
                s.push(a + '=' + c[a]);
            }
        }
        return decodeURIComponent(s.join('&'));
    }

    getAppDownlaodConfig(callback) {
        this._utility.GetCache('appdownloadconfig', () => {
            const url = this._apiUrlHelper.urlBuilder('app-download');
            return this._httpClientHelper.get(url, true)
                .pipe(map(res => {
                    // console.log(res);
                    return res;
                })).toPromise();

        }, callback, 100 * 60);
    }

    /*
    **
    */
    getRemoteConfig() {
        return this._inject.get("config").subscribe(res => {
            this._config.next({ ...res[0] })
        })
    }

}
